import Axios from '@/plugins/axios'
import { onlineUrl } from '@/utils/config';

// 营销邮件列表
export function edmSubjectList(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/list`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 当前用户使用营销邮件的状态
export function supplierState() {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/supplier-state`,
    method: 'POST',
    noMessage:true
  }
  return Axios(config);
}

// 更新状态接口(删除、撤销)
export function updateState(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/update-state`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 营销邮件效果分析-数据统计
export function analysisInfo(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/analysis-info`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 终止发送邮件
export function stopSend(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/stop-send`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
// 根据主键复制数据
export function copyById(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/copy-by-id`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 营销邮件效果分析-查看邮件人数
export function viewMailLeads(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/view-mail-leads`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
// 营销邮件效果分析-发送完成人数
export function sendRecords(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/send-records`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 营销邮件效果分析-链接点击汇总
export function mailLinkAnalysis(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/mail-link-analysis`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 营销邮件效果分析-点击邮件链接的人数
export function clickMailLinkLeads(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/click-mail-link-leads`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 创建邮件按条件搜索
export function listUsers(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/list-users`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 创建邮件查询过滤条件
export function findFilterConditions(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/find-filter-conditions`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// edm签名列表
export function signatureList() {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/signature-list`,
    method: 'GET',
  }
  return Axios(config);
}

// 保存edm签名
export function signatureSave(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-subject/signature-save`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 创建营销邮件
export function edmSubjectUpsert(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/upsert`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}

// 根据主键查询数据
export function findById(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/find-by-id`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
// 营销邮件预览发送
export function previewSend(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/preview-send`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}



// 发送统计
// 查询送达成功的邮件数据
export function querySuccesspage(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-success-page`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 查询退订列表
export function queryUnsubscribePage(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-unsubscribe-page`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
// 查询硬弹列表
export function queryHardBouncePage(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-hard-bounce-page`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
// 查询软弹列表
export function querySoftBouncePage(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-soft-bounce-page`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 查询排除列表
export function queryExcludePage(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-exclude-page`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 初始化发送统计信息
export function initSendStatistic() {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/init-send-statistic`,
    method: 'GET'
  }
  return Axios(config);
}

// 查询邮件发送历史
export function queryHistory(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/query-history`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 批量删除排除邮箱
export function delExcludeEmail(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/del-exclude-email`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 添加排除邮箱
export function addExcludeEmail(params) {
  const config = {
    url: `${ onlineUrl }/seamark/edm-send/add-exclude-email`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 查询当天余额
export function credits() {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/ai-template/credits`,
    method: 'GET',
  }
  return Axios(config);
}

// 生成邮件模板
export function generate(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/ai-template/generate`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 职位查询 
export function userTitleByKeyword(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/customer/list-user-title`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 行业查询 
export function industryByKeyword(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/customer/list-user-industry`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 职位分组查询 
export function userTitleGroupByKeyword(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/customer/user-title-group/by-keyword`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 国家区域
export function listUserCountry(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/customer/list-user-country`,
    method: 'POST',
    data:params
  }
  return Axios(config);
}

// 营销邮件-查询收件人列表
export function queryRecipient(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/query-recipient`,
    method: 'POST',
    data:params
  }
  return Axios(config);
}

// 批量校验以客户纬度是否可以发送邮件
export function sendEmailVerifyBulk(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/customer/send-email-verify-bulk/${params.uuid}`,
    method: 'GET',
    noMessage:true
  }
  return Axios(config);
}

// 批量校验联系人是否可以发送邮件
export function usersendEmailVerifyBulk(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/customer-user/send-email-verify-bulk/${params.uuid}`,
    method: 'GET',
    noMessage:true
  }
  return Axios(config);
}

// 将批量校验的id列表转换为uuid
export function verifyBulkIdsConversion(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/verify-bulk-ids-conversion`,
    method: 'POST',
    data:params,
    noMessage:true
  }
  return Axios(config);
}

